import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { api, fileUrl } from "@/lib/api";
import { useCommunity } from "@/context/CommunityContext";
import TopBar from "@/components/TopBar";
import IdeaBlock from "@/components/IdeaBlock";

const TYPE_LABEL = {
  SELF_CONFIRM: "Selbst bestätigen",
  PHOTO_UPLOAD: "Foto",
  VIDEO_UPLOAD: "Video",
  ADMIN_CONFIRM: "Gemeinde bestätigt",
  WITNESS_CONFIRM: "Zeuge bestätigt",
  CODE_CONFIRM: "Code",
  TIME_RESULT: "Zeit",
  NUMBER_RESULT: "Anzahl",
};

export default function Challenges() {
  const { community, slug } = useCommunity();
  const [data, setData] = useState({ challenges: [], places: [] });

  useEffect(() => {
    if (!slug) return;
    api.get(`/communities/${slug}/challenges`).then(({ data: payload }) => setData(payload)).catch(() => setData({ challenges: [], places: [] }));
  }, [slug]);

  const placeName = (id) => data.places.find((p) => p.id === id)?.title;

  return (
    <div data-testid="challenges-page">
      <TopBar back="/" title="Challenges" />
      <div className="mx-auto max-w-2xl px-5 py-8">
        <h1 className="text-4xl">Challenges</h1>
        <p className="mt-2 text-sm text-[var(--ink-soft)]">
          Einzelne Aufgaben an echten Orten. Finden, Sport, Foto, Bestleistungen.
        </p>

        <div className="mt-8 grid gap-4 sm:grid-cols-2">
          {data.challenges.length === 0 ? (
            <p className="rounded-2xl border bg-white p-6 text-sm text-[var(--ink-soft)]" data-testid="challenges-empty">
              Es sind noch keine Challenges freigegeben.
            </p>
          ) : null}
          {data.challenges.map((challenge, index) => (
            <Link
              key={challenge.id}
              to={`/challenges/${challenge.id}`}
              className="card-lift overflow-hidden rounded-3xl border bg-white rise"
              style={{ animationDelay: `${index * 50}ms` }}
              data-testid={`challenge-card-${challenge.id}`}
            >
              {challenge.image ? (
                <div className="h-32 w-full bg-[var(--brand-soft)]">
                  <img src={fileUrl(challenge.image)} alt="" className="h-full w-full object-cover" />
                </div>
              ) : null}
              <div className="p-5">
                <p className="eyebrow">{TYPE_LABEL[challenge.challenge_type] || "Challenge"}</p>
                <p className="mt-1 text-2xl leading-tight">{challenge.title}</p>
                {challenge.short_description ? (
                  <p className="mt-2 text-sm text-[var(--ink-soft)]">{challenge.short_description}</p>
                ) : null}
                {placeName(challenge.place_id) ? (
                  <p className="mt-3 inline-flex items-center gap-1.5 text-xs text-[var(--ink-soft)]">
                    <MapPin className="h-3.5 w-3.5" /> {placeName(challenge.place_id)}
                  </p>
                ) : null}
              </div>
            </Link>
          ))}
        </div>

        {community ? <IdeaBlock communityId={community.id} allowed={["CHALLENGE"]} /> : null}
      </div>
    </div>
  );
}
